import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export function TicketCapacityField({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  return (
    <div className="max-w-32 space-y-1">
      <Label htmlFor="ticket-type-capacity" className="text-caption text-muted-foreground">
        Quantity
      </Label>
      <Input
        id="ticket-type-capacity"
        inputMode="numeric"
        placeholder="Unlimited"
        className="h-8"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}

export function MaxPerOrderField({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  return (
    <div className="max-w-32 space-y-1">
      <Label htmlFor="ticket-type-max-per-order" className="text-caption text-muted-foreground">
        Max per Order
      </Label>
      <Input
        id="ticket-type-max-per-order"
        inputMode="numeric"
        className="h-8"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
